import { Currency, CurrencyAmount, Percent } from '@kodiak-finance/sdk-core'
import useSwapApproval from 'lib/hooks/swap/useSwapApproval'
import { ApprovalState, useApproval } from 'lib/hooks/useApproval'
import { useCallback } from 'react'
import { Trade } from 'state/routing/trades'

import { useHasPendingApproval, useTransactionAdder } from '../state/transactions/hooks'
import { TransactionType } from '../state/transactions/types'
export { ApprovalState } from 'lib/hooks/useApproval'

function useGetAndTrackApproval(getApproval: ReturnType<typeof useApproval>[1]) {
  const addTransaction = useTransactionAdder()
  return useCallback(async () => {
    const pending = await getApproval()

    if (pending) {
      const { response, tokenAddress, spenderAddress: spender } = pending
      addTransaction(response, { type: TransactionType.APPROVAL, tokenAddress, spender })
      return pending
    } else {
      throw new Error('Approval transaction was not created - likely rejected by user')
    }
  }, [addTransaction, getApproval])
}

export function useApproveCallback(
  amountToApprove?: CurrencyAmount<Currency>,
  spender?: string,
  useExactApproval = false
): [ApprovalState, () => Promise<any>] {
  const [approval, getApproval] = useApproval(amountToApprove, spender, useHasPendingApproval, useExactApproval)
  return [approval, useGetAndTrackApproval(getApproval)]
}

export function useApproveCallbackFromTrade(
  trade: Trade | undefined,
  allowedSlippage: Percent,
  amount?: CurrencyAmount<Currency>
): [ApprovalState, () => Promise<any>] {
  const [approval, getApproval] = useSwapApproval(trade, allowedSlippage, useHasPendingApproval, amount)
  return [approval, useGetAndTrackApproval(getApproval)]
}
